const namespace = "general-navbar";
const GeneralNavBar = () => {
  return <nav className={`${namespace}`}></nav>;
};
export default GeneralNavBar;
